module.exports = __webpack_public_path__ + "img/keyclock-img-hrv.b3a15f2a.png";